import { render, staticRenderFns } from "./AttendanceLogModal.vue?vue&type=template&id=5b80633c&scoped=true"
import script from "./AttendanceLogModal.vue?vue&type=script&lang=js"
export * from "./AttendanceLogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80633c",
  null
  
)

export default component.exports